<template>
  <div
    v-if="!isDisabledForSubscriber"
    v-editable="blok"
    class="inline-newsletter-cta"
  >
    <NewsletterContent
      v-if="!isComplete"
      :blok="blok?.content?.[0]"
      size="sm"
    />
    <NewsletterForm :stacked="true" @complete="onFormComplete" />
  </div>
</template>

<script setup lang="ts">
import type { InlineNewsletterCtaStoryblok } from '~/types/storyblok'
const newsletterPopupStore = useNewsletterPopupStore()
const { setFormCookie } = newsletterPopupStore
const { isDisabledForSubscriber } = storeToRefs(newsletterPopupStore)

defineProps<{
  blok: InlineNewsletterCtaStoryblok
}>()

const isComplete = ref(false)
let delayForMessage: ReturnType<typeof setTimeout>

const onFormComplete = function () {
  isComplete.value = true

  // set cookie for subscriber
  delayForMessage = setTimeout(() => {
    setFormCookie(true)
  }, 5000)
}

onUnmounted(() => {
  clearTimeout(delayForMessage)
})
</script>

<style lang="less" scoped>
.inline-newsletter-cta {
  .round(12);
  width: 100%;
  padding: @gutter-lg @gutter @gutter;
  background: @color-fill-text;
  color: @color-text-reverse;
  margin: 2.5em 0;

  @media @tablet {
    .round(18);
    padding: @gutter-lg @gutter-lg @gutter;
  }

  @media @desktop {
    padding: @gutter-xl @gutter-xl @gutter;
  }
}
</style>
